import { useRef, useState } from "react";
import {
  Box,
  CardHeader,
  IconButton,
  ImageCropper,
} from "../../../../../components";

export function AnexoMensagemLote({ imageAnexo, setImageAnexo }) {
  const imageUpload = useRef(null);
  const [tempImageAnexo, setTempImageAnexo] = useState(null);
  const [imageOverlayActive, setImageOverlayActive] = useState(false);
  const [isCropping, setIsCropping] = useState(false);

  const handleAnexoChange = (e) => {
    const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      setTempImageAnexo(reader.result);
      setIsCropping(true);
      setImageAnexo({
        originalName: file.name,
      });
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveAnexo = () => {
    setImageAnexo(null);
    if (imageUpload.current) imageUpload.current.value = "";
  };

  return (
    <>
      <CardHeader title="Anexo" />
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "200px",
          border: "1px dashed #ddd",
          borderRadius: "4px",
          backgroundColor: "#f9f9f9",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          overflow: "hidden",
          "&:hover": {
            borderColor: "#999",
          },
          ml: 1,
        }}
        onMouseOver={() => setImageOverlayActive(true)}
        onMouseLeave={() => setImageOverlayActive(false)}
      >
        <label
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {imageAnexo?.fileData ? (
            <img
              src={imageAnexo.fileData}
              alt="Preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                color: "#666",
                cursor: "pointer",
              }}
            >
              <i className="ph ph-image" style={{ fontSize: "48px" }} />
              <Box sx={{ mt: 1 }}>Clique para adicionar uma imagem</Box>
            </Box>
          )}
          <input
            accept="image/*"
            ref={imageUpload}
            type="file"
            onChange={handleAnexoChange}
            style={{ display: "none" }}
          />
        </label>

        {(imageOverlayActive || isCropping || imageAnexo) && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}
          >
            {imageAnexo && (
              <IconButton
                size="large"
                aria-label="Remover imagem"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveAnexo();
                }}
                sx={{
                  color: "white",
                  backgroundColor: "rgba(255,255,255,0.5)",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.7)",
                  },
                }}
              >
                <i className="ph ph-trash" style={{ fontSize: "48px" }} />
              </IconButton>
            )}
          </Box>
        )}
      </Box>

      {isCropping && (
        <ImageCropper
          image={tempImageAnexo}
          open={isCropping}
          onSave={(croppedDataURL) => {
            setIsCropping(false);
            setTempImageAnexo(null);
            setImageAnexo((prev) => ({ ...prev, fileData: croppedDataURL }));
          }}
          onHide={() => {
            setIsCropping(false);
            setTempImageAnexo(null);
          }}
        />
      )}
    </>
  );
}
